import {
    faArrowDown,
    faEdit,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import {
    IGetBugCardDevOpsByIDCaso,
    IResultadoBuscaCardPorIdDevops,
    IdevOpsCard,
} from "../../../../Interfaces/DevOps/DevOps";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    AddCommentInDevOpsBugController,
    CadastrarDevOpsController,
    DeleteCommentInDevOpsBugController,
    EditarBugsDevOpsController,
    LinkUnLinkBugCardsController,
    ListCommentInDevOpsBugController,
    ListFieldValuesDevOpsController,
    SearchUnlinkedBugCardsController,
    UpdateCommentInDevOpsBugController,
} from "../../../../Controllers/DevOps/DevOpsController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import InfoCardPesquisado from "./InfoCardPesquisado";
import { useUserInfor } from "../../../../Context/User";

interface htmlQuill {
    editorHtml: string;
}

interface ICardBoard {
    setShow: Dispatch<SetStateAction<boolean>>;
    getBugCardDevOpsByIDCaso: IGetBugCardDevOpsByIDCaso | undefined;
    validarEdicao: IdevOpsCard | undefined;
    GetBugCardDevOpsByIDCaso: (
        ...args: any[]
    ) => Promise<IGetBugCardDevOpsByIDCaso | undefined>;
}

export default function CardBoard(props: ICardBoard) {
    const formHook = useForm();

    const { ID_CASO, updateAtendimento, Atendimento } = useAtendimentoPage();

    const { UserInfor } = useUserInfor();

    const [uploading, setUploading] = useState(false);
    const [uploadingCriteriosAceite, setUploadingCriteriosAceite] =
        useState(false);
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [convertedTextCriteriosAceite, setConvertedTextCriteriosAceite] =
        useState<htmlQuill>({
            editorHtml: "",
        } as htmlQuill);

    const [comentarioEditando, setComentarioEditando] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);

    const [responsavel, setResponsavel] = useState(
        props.getBugCardDevOpsByIDCaso?.devOpsCard?.dS_RESPONSAVEL?.uniqueName
    );
    const [origem, setOrigem] = useState(
        props.getBugCardDevOpsByIDCaso?.devOpsCard?.dS_ORIGEM
    );
    const [tipoAtividade, setTipoAtividade] = useState(
        props.getBugCardDevOpsByIDCaso?.devOpsCard?.dS_TIPO_ATIVIDADE
    );
    const [prioridade, setPrioridade] = useState(
        props.getBugCardDevOpsByIDCaso?.devOpsCard?.dS_PRIORIDADE
    );

    const [verificarDescricao, setVerificarDescricao] = useState(false);
    const [verificarCriteriosAceite, setVerificarCriteriosAceite] =
        useState(false);
    const [editingIndex, setEditingIndex] = useState(-1);

    const valorCardPesquisado = useRef("");

    const [verificarCardNaoEncontrado, setVerificarCardNaoEncontrado] =
        useState(false);

    const [searchUnlinkedBugCardsValue, setSearchUnlinkedBugCardsValue] =
        useState<IResultadoBuscaCardPorIdDevops>();

    const [comentarioCard, setComentarioCard] = useState<string>("");

    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    function handleChangeCriteriosAceite(html: string) {
        setConvertedTextCriteriosAceite({ editorHtml: html });
    }

    function handleChangeComentarioEditando(html: string) {
        setComentarioEditando({ editorHtml: html });
    }
    const { execute: CadastrarDevOps, loading: CadastrarDevOpsLoading } =
        useAsyncCallback(CadastrarDevOpsController);

    const { execute: EditarBugsDevOps, loading: EditarBugsDevOpsLoading } =
        useAsyncCallback(EditarBugsDevOpsController);

    const {
        execute: AddCommentInDevOpsBug,
        loading: AddCommentInDevOpsBugLoading,
    } = useAsyncCallback(AddCommentInDevOpsBugController);

    const { value: ListFieldValuesDevOpsActivity } = useAsyncEffect(() =>
        ListFieldValuesDevOpsController("Activity")
    );

    const { value: ListFieldValuesDevOpsOrigem } = useAsyncEffect(() =>
        ListFieldValuesDevOpsController("Origem")
    );

    const { value: ListFieldValuesDevOpsAssignedTo } = useAsyncEffect(() =>
        ListFieldValuesDevOpsController("AssignedTo")
    );

    const { value: lstCommentInDevOpsBug, execute: ListarCommentInDevOpsBug } =
        useAsyncEffect(async () => {
            if (
                props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2?.iD_DEVOPS_CARD
            ) {
                const res = ListCommentInDevOpsBugController(
                    props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2
                        ?.iD_DEVOPS_CARD
                );
                return res;
            }
        });

    const {
        execute: SearchUnlinkedBugCards,
        loading: SearchUnlinkedBugCardsLoading,
    } = useAsyncCallback(SearchUnlinkedBugCardsController);

    const {
        execute: UpdateCommentInDevOpsBug,
        loading: UpdateCommentInDevOpsBugLoading,
    } = useAsyncCallback(UpdateCommentInDevOpsBugController);

    const {
        execute: DeleteCommentInDevOpsBug,
        loading: DeleteCommentInDevOpsBugLoading,
    } = useAsyncCallback(DeleteCommentInDevOpsBugController);

    const { execute: LinkUnLinkBugCards, loading: LinkUnLinkBugCardsLoading } =
        useAsyncCallback(LinkUnLinkBugCardsController);

    const handleEditClick = (index: number, commentBody: any) => {
        setEditingIndex(index);
        setComentarioEditando({ editorHtml: commentBody });
    };

    const handleCancelEdit = () => {
        setEditingIndex(-1);
    };

    const handleSaveEdit = (IdCommentDevOps: number) => {
        UpdateCommentInDevOpsBug(
            props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2?.iD_DEVOPS_CARD ??
                0,
            IdCommentDevOps,
            comentarioEditando.editorHtml
        ).then(() => {
            ListarCommentInDevOpsBug();
            setEditingIndex(-1);
        });
    };

    function handleSalvarComentarioCard() {
        if (comentarioCard && comentarioCard.length > 0) {
            AddCommentInDevOpsBug(
                props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2
                    ?.iD_DEVOPS_CARD ?? 0,
                comentarioCard
            ).then(() => {
                props.setShow(false);
                ListarCommentInDevOpsBug().then(() => {
                    setComentarioCard("");
                    props.setShow(true);
                });
            });
        }
    }

    function handleEnvioImagens(corpoHTML: string) {
        // Mapeia o html e substitui o src pelo link que é armazenado no state uploadedImages de forma dinamica
        let modifiedHTML = corpoHTML;
        const imagesToReplace =
            modifiedHTML.match(/<img[^>]*src="blob[^"]*"[^>]*>/g) || [];

        imagesToReplace.forEach((imageTag) => {
            const uploadedImageUrl = uploadedImages.shift() || "";
            let docsReplaced = uploadedImageUrl?.replace(
                "https://docs.google.com/uc?id=",
                "https://drive.google.com/thumbnail?id="
            );
            let driveUrl = docsReplaced + "&sz=w2000";
            modifiedHTML = modifiedHTML.replace(
                /<img[^>]*src="blob[^"]*"[^>]*>/,
                imageTag.replace(/src="blob[^"]*"/, `src="${driveUrl}"`)
            );
        });
        return modifiedHTML;
    }

    const getStatusColor = (status: string) => {
        switch (status) {
            case "New":
                return "#d3d3d3";
            case "Aguardando desenvolvimento":
                return "#ffcc99";
            case "Em desenvolvimento":
                return "#add8e6";
            case "Aguardando resposta":
                return "#cc99ff";
            case "Aguardando publicação":
                return "#ff9966";
            case "Não procedente":
                return "#ff6666";
            case "Publicação":
                return "#66ff66";
            default:
                return "#f0f0f0";
        }
    };

    function handleCadastrarCardSubmit(formData: any) {
        if (convertedText.editorHtml === "") {
            setVerificarDescricao(true);
        }
        if (convertedTextCriteriosAceite.editorHtml === "") {
            setVerificarCriteriosAceite(true);
        }

        if (props.validarEdicao) {
            if (!verificarDescricao && !verificarCriteriosAceite) {
                EditarBugsDevOps(ID_CASO, {
                    ...formData,
                    DS_DESCRICAO: handleEnvioImagens(convertedText.editorHtml),
                    DS_CRITERIOS_ACEITE:
                        convertedTextCriteriosAceite.editorHtml,
                }).then(() => {
                    props.setShow(false);
                    updateAtendimento();
                    props.GetBugCardDevOpsByIDCaso();
                    if (comentarioCard && comentarioCard.length > 0) {
                        AddCommentInDevOpsBug(
                            props.getBugCardDevOpsByIDCaso?.devOpsCardCRMV2
                                ?.iD_DEVOPS_CARD ?? 0,
                            comentarioCard
                        );
                    }
                });
            }
        } else {
            if (!verificarDescricao && !verificarCriteriosAceite) {
                CadastrarDevOps(ID_CASO, {
                    ...formData,
                    DS_DESCRICAO: handleEnvioImagens(convertedText.editorHtml),
                    DS_CRITERIOS_ACEITE:
                        convertedTextCriteriosAceite.editorHtml,
                    iD_CASO: Atendimento?.ID_CASO,
                    dS_CLIENTE: Atendimento?.DS_CONTA,
                    dT_ABERTURA_CASO: Atendimento?.DT_INICIO,
                    dS_MODULO: "Atendimento ao Cliente",
                    dS_NOME_ATENDENTE: UserInfor.DS_NOME,
                }).then((res) => {
                    props.setShow(false);
                    updateAtendimento();
                    props.GetBugCardDevOpsByIDCaso();
                    localStorage.setItem("vincularCards", String(2));
                    if (comentarioCard && comentarioCard.length > 0) {
                        AddCommentInDevOpsBug(res.id ?? 0, comentarioCard);
                    }
                });
            }
        }
    }
    useEffect(() => {
        if (
            props.getBugCardDevOpsByIDCaso &&
            props.getBugCardDevOpsByIDCaso?.devOpsCard
        ) {
            setConvertedText({
                editorHtml:
                    props.getBugCardDevOpsByIDCaso?.devOpsCard?.dS_DESCRICAO,
            });
            setConvertedTextCriteriosAceite({
                editorHtml:
                    props.getBugCardDevOpsByIDCaso?.devOpsCard
                        ?.dS_CRITERIOS_ACEITE,
            });
        }
    }, [props.getBugCardDevOpsByIDCaso]);

    return (
        <>
            {Number(localStorage.getItem("vincularCards")) === 1 &&
                !props.validarEdicao && (
                    <>
                        <div className="d-flex">
                            <input
                                className="form-control placeholder-dark-50 mr-2"
                                placeholder="Pesquisar por id do card"
                                type={"number"}
                                onChange={(e) =>
                                    (valorCardPesquisado.current =
                                        e.target.value)
                                }
                            />
                            <button
                                className="btn btn-primary font-weight-bold mr-2"
                                onClick={() => {
                                    SearchUnlinkedBugCards(
                                        valorCardPesquisado.current
                                    ).then((res) => {
                                        setSearchUnlinkedBugCardsValue(res);
                                        if (!res.devOpsCardInfo) {
                                            setVerificarCardNaoEncontrado(true);
                                        }
                                    });
                                }}
                            >
                                Pesquisar
                            </button>
                            <button
                                className="btn btn-danger font-weight-bold mr-2"
                                onClick={() => {
                                    props.setShow(false);
                                    localStorage.setItem(
                                        "vincularCards",
                                        String(0)
                                    );
                                    setTimeout(() => {
                                        props.setShow(true);
                                    }, 0);
                                }}
                            >
                                Voltar
                            </button>
                        </div>

                        {searchUnlinkedBugCardsValue &&
                        searchUnlinkedBugCardsValue.devOpsCardInfo ? (
                            <div className="d-flex flex-column align-items-center justify-content-center">
                                <span className="mt-2 font-weight-bolder py-4">
                                    {searchUnlinkedBugCardsValue.flUnlinked
                                        ? "O card não está vinculado a nenhum atendimento! Deseja vincular?"
                                        : "O card já está vinculado a um atendimento!"}
                                </span>
                                {(searchUnlinkedBugCardsValue.idCaso ===
                                    Atendimento?.ID_CASO ||
                                    !searchUnlinkedBugCardsValue.idCaso) &&
                                    (SearchUnlinkedBugCardsLoading ? (
                                        <Spinner color="primary" />
                                    ) : (
                                        <>
                                            {searchUnlinkedBugCardsValue.flUnlinked && (
                                                <InfoCardPesquisado
                                                    GetBugCardDevOpsByIDCaso={
                                                        props.GetBugCardDevOpsByIDCaso
                                                    }
                                                    ID_CASO={ID_CASO}
                                                    LinkUnLinkBugCards={
                                                        LinkUnLinkBugCards
                                                    }
                                                    searchUnlinkedBugCardsValue={
                                                        searchUnlinkedBugCardsValue
                                                    }
                                                    setShow={props.setShow}
                                                    updateAtendimento={
                                                        updateAtendimento
                                                    }
                                                    valorCardPesquisado={
                                                        valorCardPesquisado.current
                                                    }
                                                    LinkUnLinkBugCardsLoading={
                                                        LinkUnLinkBugCardsLoading
                                                    }
                                                />
                                            )}
                                        </>
                                    ))}
                            </div>
                        ) : (
                            verificarCardNaoEncontrado && (
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    <span className="mt-2 font-weight-bolder">
                                        Card não encontrado no DevOps
                                    </span>
                                </div>
                            )
                        )}
                    </>
                )}
            {(Number(localStorage.getItem("vincularCards")) === 2 ||
                props.validarEdicao) && (
                <FormProvider {...formHook}>
                    <UnForm
                        usingContext
                        handleSubmit={handleCadastrarCardSubmit}
                        className="row"
                    >
                        <div className="form-group col-12">
                            <span className="d-flex justify-content-end">
                                <h6
                                    className="p-1 px-2 rounded"
                                    style={{
                                        borderRadius: "5px",
                                        alignSelf: "flex-start",
                                        backgroundColor: getStatusColor(
                                            props.getBugCardDevOpsByIDCaso
                                                ?.devOpsCard?.dS_STATE ?? ""
                                        ),
                                    }}
                                >
                                    {props.getBugCardDevOpsByIDCaso?.devOpsCard
                                        ?.dS_STATE ?? ""}
                                </h6>
                            </span>
                        </div>
                        <div className="form-group col-12 col-lg-8">
                            <UnForm.Input
                                type="text"
                                name="DS_TITULO"
                                label="Título"
                                defaultValue={
                                    props.getBugCardDevOpsByIDCaso?.devOpsCard
                                        ?.dS_TITULO
                                }
                                registerOptions={{
                                    required: "Insira o título do card",
                                }}
                            />
                        </div>
                        <div className="form-group col-12 col-lg-4">
                            <UnForm.Select
                                name="DS_RESPONSAVEL"
                                label="Responsável"
                                value={responsavel}
                                onChange={(event) =>
                                    setResponsavel(event.target.value)
                                }
                                registerOptions={{
                                    required:
                                        "Selecione um usuário responsável",
                                }}
                            >
                                <option></option>
                                {ListFieldValuesDevOpsAssignedTo?.response.map(
                                    (item: any) => (
                                        <option
                                            key={item.uniqueName}
                                            value={item.uniqueName}
                                        >
                                            {item.displayName}
                                        </option>
                                    )
                                )}
                            </UnForm.Select>
                        </div>

                        <div className="form-group col-12 col-lg-4">
                            <UnForm.Select
                                name="DS_ORIGEM"
                                label="Origem"
                                value={origem}
                                onChange={(event) =>
                                    setOrigem(event.target.value)
                                }
                                registerOptions={{
                                    required: "Selecione uma origem",
                                }}
                            >
                                <option></option>
                                {ListFieldValuesDevOpsOrigem?.response.map(
                                    (item) => (
                                        <option key={item} value={item}>
                                            {item}
                                        </option>
                                    )
                                )}
                            </UnForm.Select>
                        </div>

                        <div className="form-group col-12 col-lg-4">
                            <UnForm.Select
                                name="DS_TIPO_ATIVIDADE"
                                label="Tipo de Atividade"
                                value={tipoAtividade}
                                onChange={(event) =>
                                    setTipoAtividade(event.target.value)
                                }
                                registerOptions={{
                                    required: "Selecione um tipo de atividade",
                                }}
                            >
                                <option value=""></option>
                                {ListFieldValuesDevOpsActivity?.response.map(
                                    (item) => (
                                        <option key={item} value={item}>
                                            {item}
                                        </option>
                                    )
                                )}
                            </UnForm.Select>
                        </div>

                        <div className="form-group col-12 col-lg-4">
                            <UnForm.Select
                                name="DS_PRIORIDADE"
                                label="Prioridade"
                                value={prioridade}
                                onChange={(event) =>
                                    setPrioridade(Number(event.target.value))
                                }
                                registerOptions={{
                                    required: "Selecione a prioridade",
                                }}
                            >
                                <option value={""}></option>
                                <option value="1">1. Padrão</option>
                                <option value="2">2. Emergente</option>
                                <option value="3">3. Urgente</option>
                                <option value="4">4. Churn Risk</option>
                            </UnForm.Select>
                        </div>

                        <div className="form-group col-12 col-lg-12">
                            <label>Descrição</label>
                            {uploading && (
                                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                    Fazendo upload de imagem{" "}
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}
                            <FroalaEditor
                                value={convertedText.editorHtml}
                                onChange={handleChange}
                                onImageUploadStart={() => setUploading(true)}
                                onImageUploadEnd={() => setUploading(false)}
                                setUploadedImages={setUploadedImages}
                            />
                            {verificarDescricao &&
                                convertedText.editorHtml === "" && (
                                    <span
                                        className="text-danger"
                                        style={{
                                            fontSize: "0.9rem",
                                            fontWeight: "400",
                                        }}
                                    >
                                        Insira a descrição
                                    </span>
                                )}
                        </div>

                        <div className="form-group col-12 col-lg-12">
                            <label>Critérios de Aceite</label>
                            {uploadingCriteriosAceite && (
                                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                    Fazendo upload de imagem{" "}
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}
                            <FroalaEditor
                                value={
                                    convertedTextCriteriosAceite.editorHtml ||
                                    ""
                                }
                                onChange={handleChangeCriteriosAceite}
                                onImageUploadStart={() =>
                                    setUploadingCriteriosAceite(true)
                                }
                                onImageUploadEnd={() =>
                                    setUploadingCriteriosAceite(false)
                                }
                            />
                            {verificarCriteriosAceite &&
                                convertedTextCriteriosAceite.editorHtml ===
                                    "" && (
                                    <span
                                        className="text-danger"
                                        style={{
                                            fontSize: "0.9rem",
                                            fontWeight: "400",
                                        }}
                                    >
                                        Insira os critérios de aceite
                                    </span>
                                )}
                        </div>
                        <div className="form-group col-12 col-lg-12">
                            <UnForm.Textarea
                                name=""
                                noRezise
                                rows={3}
                                label="Comentário"
                                onChange={(e) =>
                                    setComentarioCard(e.target.value)
                                }
                            />
                            {props.validarEdicao && (
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-success mt-2"
                                        onClick={handleSalvarComentarioCard}
                                        disabled={AddCommentInDevOpsBugLoading}
                                        type="button"
                                    >
                                        {AddCommentInDevOpsBugLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            "Salvar"
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                        {props.validarEdicao &&
                            lstCommentInDevOpsBug &&
                            lstCommentInDevOpsBug.length > 0 && (
                                <div className="form-group col-12 col-lg-12">
                                    <label>Discussão</label>
                                    {DeleteCommentInDevOpsBugLoading ||
                                    UpdateCommentInDevOpsBugLoading ? (
                                        <SpinnerComponent />
                                    ) : (
                                        lstCommentInDevOpsBug.map(
                                            (comentario, index) => (
                                                <div
                                                    key={index}
                                                    className="mb-3"
                                                >
                                                    <div className="bg-light rounded p-2">
                                                        {editingIndex ===
                                                        index ? (
                                                            <div>
                                                                <div className="d-flex align-items-center mb-4">
                                                                    <img
                                                                        className="rounded-circle mr-1"
                                                                        style={{
                                                                            height: "25px",
                                                                            width: "25px",
                                                                        }}
                                                                        src={
                                                                            comentario
                                                                                .author
                                                                                .picture
                                                                        }
                                                                        alt="comentário responsável"
                                                                    />
                                                                    {
                                                                        comentario
                                                                            .author
                                                                            .displayName
                                                                    }
                                                                </div>
                                                                <div className="form-group col-12 col-lg-12">
                                                                    <FroalaEditor
                                                                        value={
                                                                            comentarioEditando.editorHtml ||
                                                                            ""
                                                                        }
                                                                        onChange={
                                                                            handleChangeComentarioEditando
                                                                        }
                                                                        onImageUploadStart={() =>
                                                                            setUploading(
                                                                                true
                                                                            )
                                                                        }
                                                                        onImageUploadEnd={() =>
                                                                            setUploading(
                                                                                false
                                                                            )
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className="d-flex justify-content-end">
                                                                    <button
                                                                        className="btn btn-primary font-weight-bold mr-2"
                                                                        onClick={() =>
                                                                            handleSaveEdit(
                                                                                comentario.commentID
                                                                            )
                                                                        }
                                                                    >
                                                                        Salvar
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-danger font-weight-bold"
                                                                        onClick={
                                                                            handleCancelEdit
                                                                        }
                                                                    >
                                                                        Cancelar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <div className="d-flex justify-content-between  align-items-center my-4">
                                                                    <div>
                                                                        <img
                                                                            className="rounded-circle mr-1"
                                                                            style={{
                                                                                height: "25px",
                                                                                width: "25px",
                                                                            }}
                                                                            src={
                                                                                comentario
                                                                                    .author
                                                                                    .picture
                                                                            }
                                                                            alt="comentário responsável"
                                                                        />
                                                                        {
                                                                            comentario
                                                                                .author
                                                                                .displayName
                                                                        }
                                                                    </div>
                                                                    <div className="ml-auto">
                                                                        {comentario.flCanEdit && (
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faEdit
                                                                                }
                                                                                className="text-primary"
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleEditClick(
                                                                                        index,
                                                                                        comentario.commentBody
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faTrash
                                                                            }
                                                                            className="text-danger ml-2"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                Swal.fire(
                                                                                    {
                                                                                        title: "Deseja apagar este comentário?",
                                                                                        icon: "info",
                                                                                        buttonsStyling:
                                                                                            false,
                                                                                        confirmButtonText:
                                                                                            "<i class='la la-check'></i> Sim!",
                                                                                        showCancelButton:
                                                                                            true,
                                                                                        cancelButtonText:
                                                                                            "<i class='la la-thumbs-down'></i> Não",
                                                                                        customClass:
                                                                                            {
                                                                                                confirmButton:
                                                                                                    "btn btn-outline-success",
                                                                                                cancelButton:
                                                                                                    "btn btn-default",
                                                                                            },
                                                                                    }
                                                                                ).then(
                                                                                    (
                                                                                        result
                                                                                    ) => {
                                                                                        if (
                                                                                            result.isConfirmed
                                                                                        ) {
                                                                                            DeleteCommentInDevOpsBug(
                                                                                                props
                                                                                                    .getBugCardDevOpsByIDCaso
                                                                                                    ?.devOpsCardCRMV2
                                                                                                    ?.iD_DEVOPS_CARD ??
                                                                                                    0,
                                                                                                comentario.commentID
                                                                                            ).then(
                                                                                                () => {
                                                                                                    ListarCommentInDevOpsBug();
                                                                                                }
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: comentario.commentBody.replace(
                                                                            /<img/g,
                                                                            `<img style='width: 100%'`
                                                                        ),
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        )
                                    )}
                                </div>
                            )}

                        <UnForm.SubmitButton
                            color={props.validarEdicao ? "primary" : "success"}
                            iconSize="lg"
                            className="font-weight-bold col-12"
                            icon={props.validarEdicao ? faEdit : faPlus}
                            loading={
                                props.validarEdicao
                                    ? EditarBugsDevOpsLoading
                                    : CadastrarDevOpsLoading ||
                                      AddCommentInDevOpsBugLoading
                            }
                            loadingSize="sm"
                            disabled={uploading}
                        >
                            {props.validarEdicao ? "Salvar" : "Cadastrar"}
                        </UnForm.SubmitButton>
                        {props.validarEdicao && (
                            <div className="col-12">
                                <button
                                    type="button"
                                    className={`btn btn-danger d-flex align-items-center justify-content-center font-weight-bold col-12 mt-2`}
                                    onClick={() => {
                                        Swal.fire({
                                            title: "Deseja desvincular esse card do atendimento?",
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                LinkUnLinkBugCards(
                                                    Number(
                                                        props
                                                            .getBugCardDevOpsByIDCaso
                                                            ?.devOpsCardCRMV2
                                                            ?.nR_CARD_DEVOPS
                                                    ),
                                                    ID_CASO,
                                                    false
                                                ).then(() => {
                                                    props.setShow(false);
                                                    updateAtendimento();
                                                    props.GetBugCardDevOpsByIDCaso();
                                                    localStorage.setItem(
                                                        "vincularCards",
                                                        "0"
                                                    );
                                                });
                                            }
                                        });
                                    }}
                                >
                                    {LinkUnLinkBugCardsLoading ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <FontAwesomeIcon
                                            icon={faArrowDown}
                                            className="mr-2"
                                        />
                                    )}{" "}
                                    Desvincular
                                </button>
                            </div>
                        )}
                    </UnForm>
                </FormProvider>
            )}
        </>
    );
}
